export default {
  common: {
    price: '{{currency}} {{amount}}',
    dateRange: '{{from}} - {{to}}',
    currencyJpy: 'JPY',
    suggestVisitingTime: '滞在時間の目安',
    searchIcon: '✦',
    zoomIn: '+',
    zoomOut: '−',
    back: '←'
  },
  home: {
    searchPlaceholder: 'どこへ行きたいですか？',
    scale800m: '徒歩15分 (800m)',
    scale2km: '地下鉄2駅以内 (2km)',
    scale5km: '地下鉄5駅以内 (5km)',
    nearbyCount: '{{count}} 件',
    listMode: 'リスト表示',
    mapMode: '地図表示',
    exploreNearby: '近くを探す',
    filterAll: 'すべて',
    tataGreeting: 'やあ、tataだよ\n{{city}}、まだまだあるよ、他も見てみる？',
    tataGreetingFallback:
      'こんにちは、tataだよ\n一緒にもっと楽しいスポットを見つけよう〜'
  },
  search: {
    noResults: '結果がありません',
    youMayLike: 'あなたへのおすすめ',
    whereNext: '次はどこへ？'
  },
  booking: {
    ticketInfo: 'チケット情報',
    viewTicket: '電子チケットを見る',
    plan: 'プラン',
    date: '参加日',
    participants: '参加人数',
    highlights: 'おすすめポイント',
    openingHours: '営業時間',
    address: '住所',
    officialSite: '公式サイト',
    goingTo: 'まもなく{{title}}へ',
    nextStation: '次のスポットへ'
  },
  profile: {
    backToMap: 'マップに戻る',
    my: 'マイページ',
    tickets: 'チケット',
    favourites: 'お気に入り',
    exploreMore: 'もっと探索',
    viewMap: '地図を見る'
  },
  bookmarks: {
    myBookmarks: 'マイお気に入り',
    empty: 'お気に入りはありません'
  },
  tickets: {
    myTickets: 'マイチケット',
    quantity: '数量',
    viewTicket: 'チケットを見る',
    empty: 'チケットはありません'
  },
  voucher: {
    scanCode: 'QRコードをご提示ください',
    useEticket: 'タップして電子チケットを使用',
    ticketDetail: 'チケット詳細',
    notification:
      '詳細情報や窓口での引き換えは「チケット詳細」をタップしてください',
    orderId: '注文ID：{{id}}'
  },
  poi: {
    highlights: 'おすすめポイント',
    openingHours: '営業時間',
    address: '住所',
    officialWebsite: '公式サイト',
    adultTicket: '大人チケット',
    priceFrom: '{{price}} から',
    buyTicket: 'チケットを購入',
    viewDetails: '詳細を見る',
    freeAdmission: '入場無料',
    ratingCount: '{{n}}件の評価',
    star: '★',
    clock: '🕐',
    nearbyRecommend: '周辺のおすすめ',
    recentEvents: '最新イベント',
    distanceTo: '{{name}}から{{distance}}',
    aiGenerated: 'このコンテンツはAIで生成されました',
    goingTo: 'まもなく',
    categories: {
      experience: '体験',
      nature: '自然',
      attraction: '観光施設',
      gourmet: 'グルメ',
      shopping: 'ショッピング'
    }
  },
  event: {
    tag: 'イベント',
    period: '開催期間',
    duration: '所要時間',
    officialWebsite: 'イベント公式サイト'
  }
};
